// extracted by mini-css-extract-plugin
export var printerCard = "_hb-1";
export var printerCardConfigured = "_hb-2";
export var printerCardError = "_hb-3";
export var printerCardsContainer = "_hb-0";
export var printerIcon = "_hb-8";
export var printerIconConfigured = "_hb-5";
export var printerIconContainer = "_hb-4";
export var printerIconError = "_hb-6";
export var printerIconUnconfigured = "_hb-7";
export var workstationsTableCard = "_hb-9";